import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, DATETIME, UUID, ITEM } from '@/plugins/sdk/fields'
import RateSurcharge from '@/plugins/sdk/resources/RateSurcharge'
import CarrierService from '@/plugins/sdk/resources/Carrier/Service'

export default class extends Resource {
  static name = 'ratesurcharge_service'

  static get fields () {
    return {
      id: new UUID(),
      deleted: new BOOLEAN(),
      deleted_date: new DATETIME(),
      rate_surcharge: new ITEM(RateSurcharge),
      carrier_service: new ITEM(CarrierService)
    }
  }
}
